import dynamic from "next/dynamic";
import WelcomeNewJoinersHeaderConfig from "./welcome-new-joiners-header-config";
import WelcomeNewJoinersHeaderAdvancedConfig from "./welcome-new-joiners-header-advanced-config";
const WelcomeNewJoinersHeaderComponent = dynamic(()=>import("./welcome-new-joiners-header-component"));
export default {
    WelcomeNewJoinersHeaderComponent,
    WelcomeNewJoinersHeaderConfig,
    WelcomeNewJoinersHeaderAdvancedConfig
};
